// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

//TEMP, remove once the DEBUG navigate is removed
import { Router } from '@angular/router';
//TEMP

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';
import { CASValidate } from '../../shared/library/casValidate';
import { exportCsvDTO } from '../../shared/library/export';

//Models
import { dto_for_DV1_UpdateTagsForResourceConcernCategory_Request } from "../../shared/dtos/practices/dto_for_DV1_UpdateTagsForResourceConcernCategory_Request.js";
import { dto_for_DV1_UpdateResourceConcernCategoriesForTag_Request } from "../../shared/dtos/practices/dto_for_DV1_UpdateResourceConcernCategoriesForTag_Request.js";

//Token
import { authToken } from '../../shared/authToken';

//Classes
import { FormAction } from "../../shared/classes/formAction";


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// TaggingResourceConcernCategory
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.tag-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.tag-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.tag-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.tag-legend-item-div{margin:0 16px 0 2px}.tag-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.tag-control-lbl{margin-right:4px}.tag-filter-radio{padding-left:10px;display:flex;align-items:center}.tag-main-control-break{flex-basis:100%;height:0}.tag-control-div{display:flex;align-items:center;margin:20px 0 10px 0;padding-left:20px;font-size:12px}.tag-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:25px 15px 10px 25px;margin:0 10px;max-width:900px}.tag-ui-flex-field-div{margin:0 0 0 0;display:flex;align-items:center}.tag-ui-flex-field-lbl{white-space:nowrap;flex-wrap:nowrap}.tag-upper-div{flex-grow:0}.tag-lower-div{position:relative;flex-grow:1;border-top:solid 1px #ccc}.tag-ui-popup-edit{width:625px;max-width:625px;overflow:hidden}.tag-ui-popup-export{width:500px;max-width:500px}.tag-ui-dates-block{display:flex}.tag-cssClasses_Grid{border-top:solid 1px #bbb}.tag-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.tag-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.tag-cssClasses_EditableCell_complete{border:solid 1px green !important}.tag-cssClasses_Grid_MS{border-bottom:none !important}.tag-cssClasses_Body_MS{border:solid 1px #b8b8b8;border-radius:2px;background-color:#f0f0f0}.tag-cssClasses_Cell_MS{padding:0 2px !important}.tag-list{width:75px;height:80px;border:solid 1px #b8b8b8;padding:2px;overflow-y:auto;background-color:#f0f0f0}.tag-list-button{margin:0 5px;font-size:18px}'],
    template : '<!--Content Div-->\n<div class="tag-main-content-div" data-test-id="content_tagging_view">\n\n    <!--=========================================================================================-->\n    <!--Upper Content Area-->\n    <!--=========================================================================================-->\n    <div class="tag-upper-div">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Title -->\n        <!-- ---------------------------------------------------- -->\n        <h2 tabindex="-1" class="cpd-title-div">CPDES Advanced Tagging</h2>\n\n        <!--ENTITY Dropdown-->\n        <div class="tag-control-div">\n\n            <label class="tag-control-lbl">Select Target: <span class="cpd-required">*</span></label>\n            <select id="selEntity" [(ngModel)]="_selectedEntity" (change)="entityChanged($event)" aria-label="Select Target" aria-required="true" style="min-width:200px;">\n                <option *ngFor="let entity of _entities;" [ngValue]="entity">{{entity}}</option>\n            </select>\n\n            <div style="width:20px;"></div>\n        </div>\n\n        <div style="border-top:solid 1px #ccc; margin:15px;"></div>\n\n        <div *ngIf="this._selectedEntity == \'Resource Concern Categories\'">\n            <!--Category Filter-->\n            <div style="margin:0 10px 10px 22px; font-style:italic">For Bulk Editing select a Tag Category and Tag.</div>\n            <div class="tag-control-div" style="margin:5px 0 10px 0">\n\n                <label class="tag-control-lbl">Select Category:</label>\n                <select id="selBulkCategoryFilter" [(ngModel)]="_selectedBulkCategoryFilter" (change)="bulkCategoryFilterChanged($event)" aria-label="select category" style="min-width:200px;">\n                    <option *ngFor="let category of _bulkCategoryFilters;" [ngValue]="category">{{category.tag_category_name}}</option>\n                </select>\n\n                <div style="width:20px;"></div>\n\n                <label class="tag-control-lbl">Select Tag:</label>\n                <select id="selBulkTagFilter" [(ngModel)]="_selectedBulkTagFilter" (change)="bulkTagFilterChanged($event)" aria-label="select tag" style="min-width:200px;">\n                    <option *ngFor="let tag of _bulkTagFilters;" [ngValue]="tag">{{tag.tag_name}}</option>\n                </select>\n\n                <div style="width:20px;"></div>\n            </div>\n        </div>\n\n        <!--Filters-->\n        <div *ngIf="this._selectedEntity == \'Resource Concern Categories\'" class="tag-control-div" role="radiogroup" attr.aria-label="Resource Concern Category Filters">\n\n            <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n            <!--FY FILTER-->\n            <div>\n                <label for="selFYFilter" aria-label="Fiscal Year Filter" title="Fiscal Year Filter">Fiscal Year:</label>\n                <select id="selFYFilter" [(ngModel)]="_selectedFiscalYear" (change)="fiscalYear_filterChanged($event)">\n                    <option *ngFor="let fy of _fiscalYears;" [ngValue]="fy">{{fy}}</option>\n                </select>\n            </div>\n\n        </div>\n        <div *ngIf="this._selectedEntity == \'Resource Concern Categories\' && _isBulkTagSelected" class="tag-control-div" style="margin:10px 0 5px 0;" role="radiogroup" aria-labelledby="divRadioLabel">\n\n            <div style="border-top:solid 1px #ccc; margin:10px 0;"></div>\n\n            <div id="divRadioLabel">&nbsp;Filter By:</div>\n\n            <!--ALL-->\n            <div class="tag-filter-radio" (click)="taggingFilterUpdatedBulk(\'all\')" (keyEnter)="taggingFilterUpdatedBulk(\'all\')">\n                <input checked="checked" tabindex="0" id="rdoShowAll" type="radio" value="all" name="taggingFilter" [(ngModel)]="_selectedTagFilter" />\n                <label for="rdoShowAll" aria-label="No practice filter" class="cpd-focusable">All</label>\n            </div>\n\n            <!--SELECTED-->\n            <div class="tag-filter-radio" (click)="taggingFilterUpdatedBulk(\'selected\')" (keyEnter)="taggingFilterUpdatedBulk(\'selected\')">\n                <input tabindex="0" id="rdoShowSelected" type="radio" value="selected" name="taggingFilter" [(ngModel)]="_selectedTagFilter" />\n                <label for="rdoShowSelected" class="cpd-focusable">Selected</label>\n            </div>\n\n            <!--UNSELECTED-->\n            <div class="tag-filter-radio" (click)="taggingFilterUpdatedBulk(\'unselected\')" (keyEnter)="taggingFilterUpdatedBulk(\'unselected\')">\n                <input tabindex="0" id="rdoShowUnselected" type="radio" value="unselected" name="taggingFilter" [(ngModel)]="_selectedTagFilter" />\n                <label for="rdoShowUnselected" class="cpd-focusable">Unselected</label>\n            </div>\n\n        </div>\n\n\n    </div>\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Grid Div -->\n    <!-- ---------------------------------------------------- -->\n    <ng-container *ngIf="this._selectedEntity == \'Resource Concern Categories\'">\n        <div class="tag-main-grid-div" style="margin-top:5px;">\n            <cas-grid #resourceConcernCategoryGrid\n                      summary="Resource Concern Categories"\n                      [settings]="_resourceConcernCategoryGridSettings"\n                      (onRowSelectionChanged)="gridSelectionChanged()"\n                      (onRowSelected)="gridRowSelected($event)"\n                      (onRowUnSelected)="gridRowUnSelected($event)"\n                      (onRefreshClicked)="gridRefreshClicked()"\n                      (onCellClicked)="onCellClicked($event)"\n                      (onSearch)="onGridSearch($event)">\n            </cas-grid>\n        </div>\n    </ng-container>\n\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="advanced_tagging_resource_concern_category_page_popups"></div>\n\n    <!--========================================-->\n    <!-- Resource Concern Category Tagging Edit Popup -->\n    <!--========================================-->\n    <modal #popEditTagging\n           title="Update Resource Concern Category Tags"\n           containerId="advanced_tagging_resource_concern_category_page_popups"\n           label="popEditTagging"\n           customClass="tag-ui-popup-edit">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_edit_tagging"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--Single Row display-->\n            <div id="popupTaggingFields" class="cpd-ui-row">\n\n                <!--Single Cell display-->\n                <div class="tag-ui-cell" style="flex-grow:1; padding-bottom:15px;">\n\n                    <!--Selected Resource Concern Display-->\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Resource Concern Category" attr.aria-label="Resource Concern"><h3>Resource Concern Category</h3></div>\n                    <div>\n                        <span style="font-weight:bold;margin-right:5px;">Resource Concern Category:</span><span>{{_selectedResourceConcernCategoryName}}</span>\n                    </div>\n                </div>\n            </div>\n            <div id="popupTaggingTags" class="cpd-ui-row">\n                <!--Spacer-->\n                <div style="height:30px;"></div>\n\n                <div class="tag-ui-cell" style="flex-grow:1; padding-bottom:15px;">\n                    <!--Edit Tag Section-->\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Tags" attr.aria-label="Tags"><h3>Tags</h3></div>\n\n                    <!--Category Filter-->\n                    <div style="display: flex; margin: 10px 10px 0px 10px">\n                        <label for="selCategoryFilter" aria-label="Category Filter" title="Category Filter " style="font-weight:bold;">Tag Category:&nbsp;</label>\n                    </div>\n                    <div style="display: flex; margin: 0px 10px 10px 10px">\n                        <select id="selCategoryFilter" [(ngModel)]="_selectedCategoryFilter" (change)="categoryFilterChanged($event)">\n                            <option *ngFor="let category of _categoryFilters;" [ngValue]="category">{{category.tag_category_name}}</option>\n                        </select>\n                    </div>\n\n                    <!--Tag Lists-->\n                    <div style="display: flex; margin: 10px; align-items: center;">\n                        <!--Left-->\n                        <cas-grid #availableTagsGrid\n                                  id="availableTagsGrid"\n                                  summary="Available Tags List"\n                                  name="availableTagsGrid"\n                                  (onRowSelected)="moveSelectedTags(_eGrid.available, _eGrid.selected)"\n                                  [settings]="_availableTags_gridSettings"></cas-grid>\n\n                        <!--Button Block-->\n                        <div style="display:flex; flex-direction:column; margin-top:20px;">\n\n                            <div id="chevAddAllTags" tabindex="0" title="Add All Tags" aria-label="Add All Tags" role="button"\n                                 class="mdi mdi-chevron-double-right icon-button tag-list-button"\n                                 (click)="moveAllTags(_eGrid.available, _eGrid.selected)"\n                                 (keyup.enter)="moveAllTags(_eGrid.available, _eGrid.selected)">\n                            </div>\n\n                            <div style="border-bottom:solid 1px #ccc; margin:5px;"></div>\n\n                            <div id="chevRemoveAllTags" tabindex="0" title="Remove All Tags" aria-label="Remove All Tags" role="button"\n                                 class="mdi mdi-chevron-double-left icon-button tag-list-button"\n                                 (click)="moveAllTags(_eGrid.selected, _eGrid.available)"\n                                 (keyup.enter)="moveAllTags(_eGrid.selected, _eGrid.available)">\n                            </div>\n\n                        </div>\n\n                        <!--Right-->\n                        <cas-grid #selectedTagsGrid\n                                  id="selectedTagsGrid"\n                                  summary="Selected Tags List"\n                                  name="selectedTagsGrid"\n                                  (onRowSelected)="moveSelectedTags(_eGrid.selected, _eGrid.available)"\n                                  [settings]="_selectedTags_gridSettings"></cas-grid>\n                    </div>\n\n\n                </div>\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal();">Cancel</button>\n            <button type="button" accesskey="s" class="btn btn-primary" (click)="saveTags();"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n    <!--========================================-->\n    <!-- Export Resource Concern Category Tag History Popup -->\n    <!--========================================-->\n    <modal #popExportResourceConcernCategoryTagHistory\n           containerId="advanced_tagging_resource_concern_category_page_popups"\n           title="Resource Concern Category Tag History Export"\n           label="popExportResourceConcernCategoryTagHistory"\n           customClass="tag-ui-popup-export">\n\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_resource_concern_category_tagging_export_history"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--For 508-->\n            <div style="position:relative; top:-8px; left:5px; font-style:italic;">Date fields are optional.</div>\n\n            <!--Dates Block-->\n            <div class="tag-ui-dates-block">\n\n                <!--Start Date-->\n                <div class="tag-ui-flex-field-div" style="margin-left:5px;">\n                    <label for="exportStartDate" class="tag-ui-flex-field-lbl">\n                        Start Date:&nbsp;\n                    </label>\n                    <div class="cpd-ui-field-div">\n                        <input type="date"\n                               placeholder="m/d/yyyy"\n                               id="exportStartDate" name="exportStartDate"\n                               data-cval-msg-element-id="ex_start_date_vmsg"\n                               data-cval-fld-name="Start Date"\n                               [attr.data-cval-required]="false"\n                               [attr.data-cval-date]="true"\n                               style="width:140px;"\n                               aria-label="Start date (format m/d/yyyy)"\n                               (input)="_formChanged(\'popExportResourceConcernCategoryTagHistory_body\')"\n                               class="cval form-control"\n                               [ngModel]="_exportStartDate"\n                               (ngModelChange)="_exportStartDate=$event; _formChanged(\'popExportResourceConcernCategoryTagHistory_body\')" />\n\n                    </div>\n                </div>\n\n                <!--Spacer-->\n                <div style="width:20px;"></div>\n\n                <!--End Date-->\n                <div class="tag-ui-flex-field-div" style="flex-grow:1;">\n                    <label for="exportEndDate" class="tag-ui-flex-field-lbl">End Date:&nbsp;</label>\n                    <div class="cpd-ui-field-div">\n                        <input type="date"\n                               placeholder="m/d/yyyy"\n                               id="exportEndDate" name="exportEndDate"\n                               data-cval-msg-element-id="ex_end_date_vmsg"\n                               data-cval-fld-name="End Date"\n                               [attr.data-cval-required]="false"\n                               [attr.data-cval-date]="true"\n                               style="width:140px;"\n                               aria-label="End date (format m/d/yyyy)"\n                               (input)="_formChanged(\'popExportResourceConcernCategoryTagHistory_body\')"\n                               class="cval form-control"\n                               [ngModel]="_exportEndDate"\n                               (ngModelChange)="_exportEndDate=$event; _formChanged(\'popExportResourceConcernCategoryTagHistory_body\')" />\n                    </div>\n                </div>\n            </div>\n            <div>\n\n                <!--Start Date validation message-->\n                <div id="ex_start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                <!--End Date validation message-->\n                <div id="ex_end_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" (click)="exportResourceConcernCategoryTagHistory()">Export</button>\n        </footer>\n\n    </modal>\n\n</div>',
    providers: [],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})

export class TaggingResourceConcernCategoryComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('resourceConcernCategoryGrid') resourceConcernCategoryGrid;
    @ViewChild('availableTagsGrid') availableTagsGrid;
    @ViewChild('selectedTagsGrid') selectedTagsGrid;
    @ViewChild('popEditTagging') popEditTagging;
    @ViewChild('popExportResourceConcernCategoryTagHistory') popExportResourceConcernCategoryTagHistory;

    //Class wide member reference for the growls control
    growlBox = null;

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'advancedTagging.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'tagging'; //Just a shortcut (also helpful for cut & paste)
    _pageLoading = true;
    _popupDirty = false;
    _sessionStorageObject = null;
    _selectedTagFilter = 'all';
    _tooltipJawsText = 'Click to Update Tags for Resource Concern Category ';

    //Data
    _selectedRow = null;
    _selectedResourceConcernCategoryId = null;
    _selectedResourceConcernCategoryName = "";
    _entities = [];
    _selectedEntity = "";
    _exportEndDate = null;
    _exportStartDate = null;
    _fiscalYears = [];
    _selectedFiscalYear = null;

    // Track the tag changes we want to make
    _tagsByIdToAdd = [];
    _tagsByIdToRemove = [];

    _categoryFilters = [];
    _selectedCategoryFilter = this._categoryFilters[0];

    _allTags = [];
    _resourceConcernCategoryTags = [];
    _originalResourceConcernCategoryTags = [];

    // Track the resource concern category changes we want to make in obj format so we can make indexed changes
    _resourceConcernCategoriesByIdToAdd = {}
    _resourceConcernCategoriessByIdToRemove = {}

    // Bulk Editing filters
    _bulkCategoryFilters = [];
    _selectedBulkCategoryFilter = this._bulkCategoryFilters[0];
    _bulkTagFilters = [];
    _selectedBulkTagFilter = this._bulkTagFilters[0];
    _isBulkTagSelected = false;

    //"Enum" to make grid references a little easier
    _eGrid = {
        available: 1,
        selected: 2
    };

    //ResourceConcernCategory Grid
    _resourceConcernCategoryGridSettings = {
        hideClearSelectedButton: true,
        hideSearchBox: false,
        multiSelect: true,
        showCheckboxColumn: true,
        positionAbsolute: true,
        rows: [],
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "resource_concern_category_name",
        rowIdentityPrefixForJAWS: "Resource Concern Category",
        cssClasses_Grid: "tag-cssClasses_Grid",
        cssClasses_Cell: "tag-cssClasses_Cell",
        columns: [
            { fieldName: 'resource_concern_category_name', display: 'Category Name', width: '40%' },
            { fieldName: 'resource_concern_category_display', display: 'Category Display', width: '40%' },
            { fieldName: 'total_tags', display: 'Total Tags', width: '10%', toolTipFn: (cellValue, row) => { return row.total_tags > 0 ? row.hidden_tag_csv : '0'; }, ariaCellFn: (cellValue, row) => { return row.total_tags > 0 ? this._tooltipJawsText + row.resource_concern_category_name + ' ' + row.hidden_tag_csv : this._tooltipJawsText + row.resource_concern_category_name; }, templateFn: (cellValue, row) => { return this._generateResourceConcernCategoriesTagsLink(row.total_tags); }, columnHeaderToolTip: "Click on the Total Tags count to update tags for selected Resource Concern Category." }
        ]
    };

    //Available Tags grid
    _availableTags_gridSettings = {
        height: 120, width: 140,
        loading: true,
        multiSelect: true,
        showCheckboxColumn: false,
        showMessageWhenEmpty: false,
        hideControlRow: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "tag_name",
        rowIdentityPrefixForJAWS: "Tag Name",
        cssClasses_Grid: "tag-cssClasses_Grid_MS",
        cssClasses_Cell: "tag-cssClasses_Cell_MS",
        cssClasses_Body: "tag-cssClasses_Body_MS",
        columns: [{ fieldName: 'tag_name', display: 'Available Tags', width: '100%' }],
        rows: []
    };

    //Selected Tags grid
    _selectedTags_gridSettings = {
        height: 120, width: 140,
        loading: true,
        multiSelect: true,
        showCheckboxColumn: false,
        showMessageWhenEmpty: false,
        hideControlRow: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "tag_name",
        rowIdentityPrefixForJAWS: "Tag Name",
        cssClasses_Grid: "tag-cssClasses_Grid_MS",
        cssClasses_Cell: "tag-cssClasses_Cell_MS",
        cssClasses_Body: "tag-cssClasses_Body_MS",
        columns: [{ fieldName: 'tag_name', display: 'Selected Tags', width: '100%' }],
        rows: []
    };



    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        domSanitizer: DomSanitizer,
        helpers: Helpers,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        this._disableControls = false;

        // Validation
        //--------------
        this.casValidate = new CASValidate(this);

        //Init the local storage for this page
        this._sessionStorageObject = this._loadSessionStorageObject();

        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedEntity: null
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        // Growl Prep
        //--------------------
        this.initalizeGrowlBox();

        // Load entities
        this.initEntities();
        if (this._sessionStorageObject.selectedEntity == "Resource Concern Categories") {
            this._selectedEntity = this._sessionStorageObject.selectedEntity;
        }

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = this._selectedEntity != "" ? document.getElementById("selEntity") : document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        // Load the form fields
        //-----------------------------------
        this.casNavBoxService.ActionsLoading = true;
        this.loadActionLinks();

        let ops = 3;

        this.loadTagCategories(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        this.initFiscalYears(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        this.initResourceConcernCategoryGrid(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });
    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {
        this.casValidate.initialize(true);

        this._pageLoading = false;
    };

    //========================================
    // initalizeGrowlBox
    //========================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    };

    // EVENT HANDLERS
    //------------------------------------------------------------------------------------------------------------------------
    //==================================
    // bulkCategoryFilterChanged
    //==================================
    bulkCategoryFilterChanged(e) {

        this._isBulkTagSelected = false;
        this._selectedTagFilter = "all";
        this.loadActionLinks();
        this.loadAllTags(this._selectedBulkCategoryFilter.tag_category_id);
        this._selectedBulkTagFilter = this._bulkTagFilters[0];
        this.initResourceConcernCategoryGrid();
    };

    //==================================
    // bulkTagFilterChanged
    //==================================
    bulkTagFilterChanged(e) {

        if (this._selectedBulkTagFilter.tag_id == null) {
            this._isBulkTagSelected = false;
            this._selectedTagFilter = "all";
        }
        else {
            this._isBulkTagSelected = true;
        }
        this.loadActionLinks();
        this.initResourceConcernCategoryGrid();

    };

    //==================================
    // categoryFilterChanged
    //==================================
    categoryFilterChanged(e) {

        this.loadAllTags(null, () => {

            let availableTags = this._allTags;

            //Filter available tags by Category
            if (this._selectedCategoryFilter.tag_category_name != "All") {
                availableTags = availableTags.filter((tag) => { return tag.tag_category_id == this._selectedCategoryFilter.tag_category_id });
            }

            //Remove tags if in selected list
            for (let aTag of this._resourceConcernCategoryTags) {

                let idx = availableTags.findIndex((tag) => { return tag.tag_id == aTag.tag_id });

                if (idx == -1) { continue; }

                availableTags.splice(idx, 1);
            }

            this.sortTagData(availableTags);
            this._availableTags_gridSettings.rows = availableTags;
            this.availableTagsGrid.MarkAsLoading(false);
        });
    };


    //==================================
    // entityChanged
    //==================================
    entityChanged(e) {

        var dropDown = document.getElementById("selEntity");
        dropDown.focus();
        this.casNavBoxService._previousUrl = "/cpdes/tagging/concerncategories";

        //Save seleted entity to session
        if (this._selectedEntity) {
            this._sessionStorageObject.selectedEntity = this._selectedEntity;
            this._saveSessionStorageObject(this._sessionStorageObject);

            //Load grid according to selected entity
            switch (this._selectedEntity) {
                case "Assets":
                    let routeAssets = "/cpdes/tagging/assets";
                    this.router.navigate([routeAssets]);

                    break;

                case "Narratives":
                    let routeNarratives = "/cpdes/tagging/narratives";
                    this.router.navigate([routeNarratives]);

                    break;

                case "Resource Concerns":
                    let routeResourceConcerns = "/cpdes/tagging/resourceconcerns";
                    this.router.navigate([routeResourceConcerns]);

                    break;

                case "Resource Concern Components":
                    let routeResourceConcernComponents = "/cpdes/tagging/concerncomponents";
                    this.router.navigate([routeResourceConcernComponents]);

                    break;

                case "Resource Concern Categories":
                    this.markResourceConcernCategoryGridAsLoading(true);
                    this.loadActionLinks();
                    this.initResourceConcernCategoryGrid(() => {
                        this.ngOnInit_Complete();
                        this.markResourceConcernCategoryGridAsLoading(false);
                    });

                    break;

                default:
                    break;
            }

        }
        else {
            this._isBulkTagSelected = false;
            this.loadActionLinks();
            this._sessionStorageObject.selectedEntity = null;
            this._saveSessionStorageObject(this._sessionStorageObject);
        }

    };

    //=======================================
    // fiscalYear_filterChanged
    //=======================================
    fiscalYear_filterChanged() {

        this.clearResourceConcernCategoryGrid();
        this.markResourceConcernCategoryGridAsLoading(true);

        this.initResourceConcernCategoryGrid();

    };

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {
        if (this.resourceConcernCategoryGrid) {
            this.resourceConcernCategoryGrid.MarkAsLoading(true);
        }
        else {
            this.resourceConcernCategoryGrid.loading = true;
        }
        this._selectedRow = null;

        // Refresh grid
        this.initResourceConcernCategoryGrid(() => {
            this.ngOnInit_Complete();
            this.resourceConcernCategoryGrid.MarkAsLoading(false);
        });
    };

    //==================================
    // gridRowSelected
    //==================================
    gridRowSelected(evt) {

        let resourceConcernCategoryId = evt.resource_concern_category_id;

        if (this._resourceConcernCategoriesByIdToRemove[resourceConcernCategoryId]) {
            delete this._resourceConcernCategoriesByIdToRemove[resourceConcernCategoryId];
        }
        else {
            this._resourceConcernCategoriesByIdToAdd[resourceConcernCategoryId] = resourceConcernCategoryId;
        }

    };

    //==================================
    // gridRowUnSelected
    //==================================
    gridRowUnSelected(evt) {

        let resourceConcernCategoryId = evt.resource_concern_category_id;

        if (this._resourceConcernCategoriesByIdToAdd[resourceConcernCategoryId]) {
            delete this._resourceConcernCategoriesByIdToAdd[resourceConcernCategoryId];
        }
        else {
            this._resourceConcernCategoriesByIdToRemove[resourceConcernCategoryId] = resourceConcernCategoryId;
        }

    };

    //==================================
    // gridSelectionChanged
    //==================================
    gridSelectionChanged() {
        this.casNavBoxService.EmphasizeActionByName("act_edit_tagging");
    };


    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {
        if (!action || !action.field_name) { return; }

        switch (action.field_name.toLowerCase()) {

            case "act_edit_tagging":
                if (this._selectedEntity == "") {
                    this.growlBox.addGrowl("info", "Please select a Target");
                    return;
                }
                if (!this._isBulkTagSelected) {
                    this.growlBox.addGrowl("info", "Please select a Tag for bulk editing");
                    return;
                }

                this.SaveResourceConcernCategories();
                break;

            case "act_resource_concern_category_tag_history_export":
                this.action_exportResourceConcernCategoryTagHistory();
                break;

        }

    };

    //==================================
    // onCellClicked
    //==================================
    onCellClicked(cell) {
        if (!cell.isCheckbox && cell.col.fieldName == "total_tags") {
            this._selectedResourceConcernCategoryId = cell.row.resource_concern_category_id;
            this._selectedResourceConcernCategoryName = cell.row.resource_concern_category_name;

            this.action_openEditTagging();
        }
    };

    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText) {

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0) {
            this.resourceConcernCategoryGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.resource_concern_category_name.toLowerCase().indexOf(searchText) >= 0
                || row.resource_concern_category_display.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.resourceConcernCategoryGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    };


    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    };

    //==================================
    // taggingFilterUpdatedBulk
    //==================================
    taggingFilterUpdatedBulk(filter) {

        //jump out for unrecognized filters
        if ("all,selected,unselected".indexOf(filter) < 0) {
            throw ("[advancedTagging:_taggingFilterUpdatedBulk] Unrecognized filter");
        }

        //Set the member value
        this._selectedTagFilter = filter;

        if (filter === "all") {
            this.resourceConcernCategoryGrid.ClearFilters();
        }
        else {
            this.resourceConcernCategoryGrid.SetFilter(
                "default",
                row => ((filter === 'selected' && row.__selected) || (filter === 'unselected' && !row.__selected)),
                true);
        }
    };


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // action_exportResourceConcernCategoryTagHistory
    //=======================================
    action_exportResourceConcernCategoryTagHistory() {

        this._exportEndDate = null;
        this._exportStartDate = null;
        this.popExportResourceConcernCategoryTagHistory.Open();
    };

    //=======================================
    // action_openEditTagging
    //=======================================
    action_openEditTagging() {

        this._popupDirty = false;
        let ops = 3;
        this.availableTagsGrid.MarkAsLoading(true);
        this.selectedTagsGrid.MarkAsLoading(true);

        //Load the feature flag and set up the nav box
        this.loadAllTags(null, () => {
            if (--ops == 0) { this.populateTags(); }
        });

        //Load the asset types
        this.loadResourceConcernCategoryTags(() => {
            if (--ops == 0) { this.populateTags(); }
        });

        //Load categories
        this.loadTagCategories(() => {
            if (--ops == 0) { this.populateTags(); }
        });

        this.popEditTagging.Open();
    };

    //=======================================
    // clearResourceConcernCategoryGrid
    //=======================================
    clearResourceConcernCategoryGrid() {

        if (this.resourceConcernCategoryGrid) {
            this.resourceConcernCategoryGrid.ClearRows();
        }
        else {
            this._resourceConcernCategoryGridSettings.rows = [];
        }
    };

    //=======================================
    // closeModal
    //=======================================
    closeModal() {
        //Refresh all references to the updated tag list
        if (this._isBulkTagSelected) {
            let categoryIndex = this._bulkCategoryFilters.findIndex((cat) => { return cat.tag_category_id == this._selectedBulkCategoryFilter.tag_category_id });
            this._selectedBulkCategoryFilter = this._bulkCategoryFilters[categoryIndex];
            let tagIndex = this._bulkTagFilters.findIndex((tag) => { return tag.tag_id == this._selectedBulkTagFilter.tag_id });
            this._selectedBulkTagFilter = this._bulkTagFilters[tagIndex];
        }
    };

    //==================================
    // eGridToGrid
    //==================================
    eGridToGrid(eGrid) {

        switch (eGrid) {
            case this._eGrid.available: return { settings: this._availableTags_gridSettings, component: this.availableTagsGrid };
            case this._eGrid.selected: return { settings: this._selectedTags_gridSettings, component: this.selectedTagsGrid };
            default: throw (`eGridToGrid: Unrecognized eGrid value:${eGrid}`);
        }
    };

    //=======================================
    // exportResourceConcernCategoryTagHistory
    //=======================================
    exportResourceConcernCategoryTagHistory() {
        let dateFilter = "All";

        //Validaton
        if (this._exportEndDate && this._exportStartDate) {
            dateFilter = this._exportStartDate + "--" + this._exportEndDate;
            if (this._exportEndDate < this._exportStartDate) {
                this.growlBox.addGrowl("error", "End Date must be after Start Date.");
                return;
            }
        }
        else if (this._exportEndDate) { dateFilter = this._exportEndDate; }
        else if (this._exportStartDate) { dateFilter = this._exportStartDate; }

        let isValid = this.casValidate.isAllValid(true, "popExportResourceConcernCategoryTagHistory_body");

        if (!isValid) {
            alert("Please ensure that all field are valid and complete.");
            return;
        }

        //Export
        try {
            this.growlBox.addGrowl("info", "Exporting Resource Concern Category Tag History...");
            this.popExportResourceConcernCategoryTagHistory.Close();

            let start_date = this._exportStartDate ? new Date(this._exportStartDate.replace(/-/g, '\/')).toISOString() : null;
            let end_date = this._exportEndDate ? new Date(this._exportEndDate.replace(/-/g, '\/')).toISOString() : null;

            this.webServices.Get({
                apiPath: "/tagging/resourceCategory/exportResourceConcernCategoryTags",
                args: {
                    startDate: start_date,
                    endDate: end_date
                }
            })
                .then(res => {

                    console.log("[{0}:exportResourceConcernCategoryTagHistory():/resourceCategory/exportResourceConcernCategoryTags] - res:".format(this._componentName), res);

                    if (!res.data.DTO || res.data.DTO == "") {
                        this.growlBox.addGrowl("info", "No records found for the indicated search.");
                        return;
                    }

                    this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

                    //Popup in new window
                    exportCsvDTO(res.data.DTO, 'ResourceConcernCategoryTagHistory', dateFilter);
                })
                .catch(err => {
                    console.log("An error occured while exporting.", this.cpdFormatters.formatError(err));
                    this.growlBox.addGrowl("error", "An error occured while exporting.");
                });
        }
        catch (e) {
            console.log("An unexpected error occured while exporting", this.cpdFormatters.formatError(e));
            this.growlBox.addGrowl("error", "An unexpected error occured while exporting");
        }
    };

    //=======================================
    // _formChanged
    //=======================================
    _formChanged(modelName, event) {

        //Check the popup's validity
        let isValid = this.casValidate.isAllValid(true, modelName);
        if (isValid) {
            this._popupValid = true;
        }
        else {
            //Form is invalid
            this._popupValid = false;
        }
    };

    //=======================================
    // _generateResourceConcernCategoriesTagsLink
    //=======================================
    _generateResourceConcernCategoriesTagsLink(tagCount) {
        return "<span title='Click to update tags' class='fake-anchor' style='pointer-events:none;' >{0}</span>".format(tagCount, 80);
    };

    //=======================================
    // initEntities
    //======================================
    initEntities(fnOnComplete) {
        this._entities = ["", "Assets", "Narratives", "Resource Concerns", "Resource Concern Categories", "Resource Concern Components"];
        this._selectedEntity = this._entities[0];

        if (fnOnComplete) { fnOnComplete(); }

    };

    //=======================================
    // initFiscalYears
    //======================================
    initFiscalYears(fnOnComplete) {

        this.webServices.Get({ apiPath: "/resource/getFiscalYearRangeForAllResources" })
            .then(res => {

                console.log("[{0}:initFiscalYears():getFiscalYearRangeForAllResources()] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                this._fiscalYears = [];
                for (let i = dto.minFiscalYear; i <= dto.maxFiscalYear; i++) {
                    this._fiscalYears.push(i);
                }

                this._selectedFiscalYear = this.helpers.getFY();

                if (fnOnComplete) { fnOnComplete(); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });

    };

    //=======================================
    // initResourceConcernCategoryGrid
    //======================================
    initResourceConcernCategoryGrid(fnOnComplete) {
        this.markResourceConcernCategoryGridAsLoading(true);

        this._resourceConcernCategoriesByIdToAdd = {}
        this._resourceConcernCategoriesByIdToRemove = {}

        this.loadResourceConcernCategories((dto) => {
            this._selectedRow = null;
            if (this.resourceConcernCategoryGrid) {
                this.resourceConcernCategoryGrid.SetRows(dto);
                console.log("Resource Concern Category Tag Grid init".format(this._componentName, this._formName));
                this.taggingFilterUpdatedBulk(this._selectedTagFilter);
                this.markResourceConcernCategoryGridAsLoading(false);
            }
            else {
                this._resourceConcernCategoryGridSettings.rows = dto;
            }

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    };

    //=======================================
    // loadActionLinks
    //=======================================
    loadActionLinks() {

        //Load the form fields
        let actions = [];
        if (this._selectedEntity == "Resource Concern Categories") {
            if (this._isBulkTagSelected) {
                actions.push(new FormAction("act_edit_tagging", "Save Selected RCCats"));
            }

            actions.push(new FormAction("act_resource_concern_category_tag_history_export", "RC Category Tag History Export"));
        }
        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;

    };

    //=======================================
    // loadAllTags
    //=======================================
    loadAllTags(categoryId, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/tagging/getAllTags",
            args: {
                categoryId: categoryId,
                showActive: true
            }

        })
            .then(res => {
                console.log("[{0}:/tagging/getAllTags] - res:".format(this._componentName), res);
                this._allTags = res.data.DTO;
                this._bulkTagFilters = [{ tag_name: "", tag_id: null }].concat(res.data.DTO);

                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                console.log(err);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    };

    //==================================
    // loadTagCategories
    //==================================
    loadTagCategories(fnOnSuccess, fnOnError) {

        this.webServices.Get({
            apiPath: "/tagging/getAllTagCategories",
            args: { showActive: true }
        })
            .then(res => {
                console.log("[{0}:/tagging/getAllTagCategories] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                try {

                    //Build the category lists
                    this._categoryFilters = [{ tag_category_name: "All", tag_category_id: "" }].concat(dto);
                    this._selectedCategoryFilter = this._categoryFilters[0];
                    this._bulkCategoryFilters = dto;
                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:loadTagCategories()]".format(this._componentName), err);
                    if (fnOnError) { fnOnError(); }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

                if (fnOnError) { fnOnError(); }
            });
    };

    //=======================================
    // loadResourceConcernCategories
    //=======================================
    loadResourceConcernCategories(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/tagging/resourceCategory/getTagCounts",
            args: {
                fiscalYear_filter: this._selectedFiscalYear,
                tagId_filter: this._selectedBulkTagFilter ? this._selectedBulkTagFilter.tag_id : null,
            }
        })
            .then(res => {
                console.log("[{0}:/tagging/resourceCategory/getTagCounts] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                console.log(err);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    };

    //=======================================
    // loadResourceConcernCategoryTags
    //=======================================
    loadResourceConcernCategoryTags(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/tagging/resourceCategory/getTags",
            args: {
                resource_concern_category_id: this._selectedResourceConcernCategoryId
            }
        })
            .then(res => {
                console.log("[{0}:/tagging/resourceCategory/getTags] - res:".format(this._componentName), res);
                this._resourceConcernCategoryTags = res.data.DTO;
                this._originalResourceConcernCategoryTags = this._resourceConcernCategoryTags;
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                console.log(err);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    };

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    };

    //=======================================
    // markResourceConcernCategoryGridAsLoading
    //=======================================
    markResourceConcernCategoryGridAsLoading(isLoading) {

        if (this.resourceConcernCategoryGrid) {
            this.resourceConcernCategoryGrid.MarkAsLoading(isLoading);
        }
        else {
            this._resourceConcernCategoryGridSettings.loading = isLoading;
        }
    };

    //==================================
    // moveAllTags
    //==================================
    moveAllTags(eGridFrom, eGridTo) {
        this._popupDirty = true;

        //Grab a reference to the grids and settings we are working with
        let fromGrid = this.eGridToGrid(eGridFrom);
        let toGrid = this.eGridToGrid(eGridTo);

        //Get buffer references to the array for off screen work
        var arrSource = fromGrid.settings.rows;
        var arrDest = toGrid.settings.rows;

        //Clear the display while we work by clearing the grid references to the array in memory
        fromGrid.settings.rows = [];
        toGrid.settings.rows = [];

        //Let the UI render before moving on (this might be a little overkill given the small data size)
        window.setTimeout(() => {
            finishProcessing();
        }, 0);

        //------------------------------
        // finishProcessing
        //------------------------------
        let finishProcessing = () => {

            //Move the tags in the buffer arrays
            while (arrSource.length > 0) {
                arrDest.push(arrSource.splice(0, 1)[0]);

            }

            //Sort the populated array
            this.sortTagData(arrDest);

            //Assign the array back to the populated list
            toGrid.settings.rows = arrDest;

            //Make sure the pushed row isn't flagged as selected
            toGrid.component.UnselectAllRows();

            //Update the concern's tags list
            this.syncResourceConcernCategoryTagsList();

            //Update add and remove arrays for save
            this.populateTagsToAddRemove();
        }

    };

    //==================================
    // moveSelectedTags
    //==================================
    moveSelectedTags(eGridFrom, eGridTo) {
        this._popupDirty = true;

        //Grab a reference to the grids we are working with
        let fromGrid = this.eGridToGrid(eGridFrom);
        let toGrid = this.eGridToGrid(eGridTo);

        //Get buffer references to the array for off screen work
        var arrSource = fromGrid.settings.rows;
        var arrDest = toGrid.settings.rows;

        //Cycle through the selected, source rows and move them to the destination
        //(from high to low to avoid corrupting the indexes)
        let selectedRowIndexes = fromGrid.component.GetSelectedRowsIndexes().sort((a, b) => b - a); //Sort as number desc
        selectedRowIndexes.forEach((idx) => {
            let row = arrSource.splice(idx, 1)[0];
            arrDest.push(row);
        });

        //Make sure the pushed row isn't flagged as selected
        toGrid.component.UnselectAllRows();

        //Resort the receiving list
        this.sortTagData(arrDest);

        //Update the resource concern's tags list
        this.syncResourceConcernCategoryTagsList();

        //Update add and remove arrays for save
        this.populateTagsToAddRemove();

        //Set focus to next item in grid
        let nextRowIndex = selectedRowIndexes[0] + 1;
        if (eGridFrom == 1) {
            var nextRow = document.getElementById("availableTagsGrid").getElementsByClassName("__cas-grid-row")[nextRowIndex];
            var toGridRow = document.getElementById("selectedTagsGrid").getElementsByClassName("__cas-grid-row")[0];
        }
        else {
            var nextRow = document.getElementById("selectedTagsGrid").getElementsByClassName("__cas-grid-row")[nextRowIndex];
            var toGridRow = document.getElementById("availableTagsGrid").getElementsByClassName("__cas-grid-row")[0];
        }
        if (nextRow) {
            window.setTimeout(() => {
                nextRow.focus();
            }, 0);
        }
        else {
            window.setTimeout(() => {
                toGridRow.focus();
            }, 0);
        }
    };

    //==================================
    // populateAddRemove
    //==================================
    populateTagsToAddRemove() {

        // First clear out add and remove arrays
        this._tagsByIdToAdd = [];
        this._tagsByIdToRemove = [];

        // If tag is selected and not in original concern tags, push to add array
        for (let sTag of this._selectedTags_gridSettings.rows) {
            if (this._originalResourceConcernCategoryTags.findIndex((nTag) => { return nTag.tag_id == sTag.tag_id }) == -1) {
                this._tagsByIdToAdd.push(sTag.tag_id);
            }
        }
        //If tag is in original concerns tags and not selected, push to remove array
        for (let rTag of this._originalResourceConcernCategoryTags) {
            if (this._selectedTags_gridSettings.rows.findIndex((tag) => { return tag.tag_id == rTag.tag_id }) == -1) {
                this._tagsByIdToRemove.push(rTag.resource_category_tag_id);
            }
        }
    };

    //==================================
    // populateTags
    //==================================
    populateTags() {

        //Clear the tag lists
        this._availableTags_gridSettings.rows = [];
        this._selectedTags_gridSettings.rows = [];

        //Temp variables so we can sort offscreen
        let availableTags = [];
        let selectedTags = [];

        for (let nTag of this._resourceConcernCategoryTags) {

            //Find this tag by its tag_id in the full tags list
            let idx = this._allTags.findIndex((tag) => { return tag.tag_id == nTag.tag_id });

            //This shouldn't happen, but let's keep it silent if it does
            if (idx == -1) { continue; }

            //Move the tag into the selected tag list
            selectedTags.push(this._allTags.splice(idx, 1)[0]);
        }

        //Set the available tags list to the remaining tags in the allTags list
        availableTags = this._allTags;

        //Sort the arrays
        this.sortTagData(availableTags);
        this.sortTagData(selectedTags);

        //Render the lists on screen
        this._availableTags_gridSettings.rows = availableTags;
        this._selectedTags_gridSettings.rows = selectedTags;

        this.availableTagsGrid.MarkAsLoading(false);
        this.selectedTagsGrid.MarkAsLoading(false);

    };

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_savesessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    };

    //==================================
    // SaveResourceConcernCategories
    //==================================
    SaveResourceConcernCategories() {

        //Clear action emphasis
        this.casNavBoxService.DeEmphasizeActionByName("act_edit_tagging");

        //Put changes into a dto
        let dto = new dto_for_DV1_UpdateResourceConcernCategoriesForTag_Request();
        dto.tag_id = this._selectedBulkTagFilter.tag_id;
        dto.resource_concern_category_ids_add = Object.values(this._resourceConcernCategoriesByIdToAdd);
        dto.resource_concern_category_ids_remove = Object.values(this._resourceConcernCategoriesByIdToRemove);

        //Do we have any changes?
        if (dto.resource_concern_category_ids_add.length == 0 && dto.resource_concern_category_ids_remove.length == 0) {
            this.growlBox.addGrowl("warn", "No changes detected");
            return;
        }

        //Prep for save
        this.casNavBoxService.DisableAllLinks();
        this.growlBox.addGrowl("info", "Saving...");
        this.resourceConcernCategoryGrid.MarkAsLoading(true);

        //Do the deed
        this.webServices.Post("/tagging/resourceCategory/updateResourceConcernCategories", dto)
            .then(res => {
                if (res.Success) {
                    this.growlBox.addGrowl("success", "Record Saved");
                    this.casNavBoxService.EnableAllLinks();

                    //Refresh all references to the updated tag list
                    if (this._isBulkTagSelected) {
                        let categoryIndex = this._bulkCategoryFilters.findIndex((cat) => { return cat.tag_category_id == this._selectedBulkCategoryFilter.tag_category_id });
                        this._selectedBulkCategoryFilter = this._bulkCategoryFilters[categoryIndex];
                        let tagIndex = this._bulkTagFilters.findIndex((tag) => { return tag.tag_id == this._selectedBulkTagFilter.tag_id });
                        this._selectedBulkTagFilter = this._bulkTagFilters[tagIndex];
                    }

                    this.initResourceConcernCategoryGrid();
                    this.markResourceConcernCategoryGridAsLoading(false);
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-RCCatTBL-URCC":
                            this.growlBox.addGrowl("error", "No resource concern categories provided to change.");
                            break;
                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                }
            })
            .catch((err) => {
                this.casNavBoxService.EnableAllLinks();
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.resourceConcernCategoryGrid.MarkAsLoading(false);
            });


    };

    //=======================================
    // saveTags
    //=======================================
    saveTags() {

        //Populate dto with updates
        let dto = new dto_for_DV1_UpdateTagsForResourceConcernCategory_Request();
        dto.resource_concern_category_id = this._selectedResourceConcernCategoryId;
        dto.tag_ids_add = Object.values(this._tagsByIdToAdd);
        dto.tag_ids_remove = Object.values(this._tagsByIdToRemove);

        //Do we have any changes?
        if (dto.tag_ids_add.length == 0 && dto.tag_ids_remove.length == 0) {
            this.growlBox.addGrowl("warn", "No changes detected");
            return;
        }

        //Prep for save
        this.casNavBoxService.DisableAllLinks();
        this.markResourceConcernCategoryGridAsLoading(true);
        this.growlBox.addGrowl("info", "Saving Resource Concern Category Tags...");

        //Do the deed
        this.webServices.Post("/tagging/resourceCategory/updateTags", dto)
            .then(res => {
                //Check for validation errors
                if (res.Success) {
                    this.growlBox.addGrowl("success", "Record Saved.");
                    this.casNavBoxService.EnableAllLinks();

                    //Refresh all references to the updated tag list
                    if (this._isBulkTagSelected) {
                        let categoryIndex = this._bulkCategoryFilters.findIndex((cat) => { return cat.tag_category_id == this._selectedBulkCategoryFilter.tag_category_id });
                        this._selectedBulkCategoryFilter = this._bulkCategoryFilters[categoryIndex];
                        let tagIndex = this._bulkTagFilters.findIndex((tag) => { return tag.tag_id == this._selectedBulkTagFilter.tag_id });
                        this._selectedBulkTagFilter = this._bulkTagFilters[tagIndex];
                    }

                    this.initResourceConcernCategoryGrid();
                    this.markResourceConcernCategoryGridAsLoading(false);
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-RCCatTBL-UT":
                            this.growlBox.addGrowl("error", "No tags provided to change.");
                            break;
                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                }
            })
            .catch((err) => {
                this.casNavBoxService.EnableAllLinks();
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markResourceConcernCategoryGridAsLoading(false);
            });

        //Close the dialog
        this.popEditTagging.Close();


    };


    //==================================
    // sortTagData
    //==================================
    sortTagData(arr) {
        arr.sort((row1, row2) => {
            return row1.tag_name < row2.tag_name ? -1 : (row1.tag_name > row2.tag_name ? 1 : 0);
        });
    };

    //==================================
    // syncResourceConcernCategoryTagsList
    //==================================
    // Looks at the current selected tag lists/grids and syncs the current category to match
    syncResourceConcernCategoryTagsList() {

        this._resourceConcernCategoryTags = [];

        this._selectedTags_gridSettings.rows.forEach((row) => {
            this._resourceConcernCategoryTags.push(row);
        });

    };

};